export default __webpack_public_path__ + "static/media/luikwervelMarseille.jpg";